import { App } from '@vue/runtime-core';
import ScoringFormPageService from '@/pages/ScoringFormPage/lib/Service/ScoringFormPageService';
import IServiceContainer from '@/shared/ServiceContainer/Contract/IServiceContainer';

export default {
  install: (app: App, options: { serviceContainer: IServiceContainer }) => {
    app.provide('scoringFormPage', new ScoringFormPageService(options.serviceContainer));
  },
};
